import { createComponent } from '@/common/util/templateHelpers';
import { App, Layout, Container, Flex, RouterLink } from '@/common/components';

import AppHeader from '@/components/AppHeader';
import AppFooter from '@/components/AppFooter';

import style from './index.module.scss';
import Menu, { MenuList } from '@/common/components/Menu';

export default createComponent('AboutPageLayout', { style }, function AboutPageLayout ({ className }, props) {
  return (
    <Layout className={className}>
      <App.Header>
        <AppHeader />
      </App.Header>

      <App.Main>
        <Container>
          <Flex collapseMobile container gap2>
            <Flex oneQuarter>
              <Menu>
                <MenuList>
                  <li><RouterLink href='/about/terms-use'>Terms of Use Agreement</RouterLink></li>
                  <li><RouterLink href='/about/contact-us'>Contact Us</RouterLink></li>
                  <li><RouterLink href='/about/about-us'>About Addicting Games</RouterLink></li>
                  <li><RouterLink href='/about/user-submission-agreement'>Addicting Games User Submission Agreement</RouterLink></li>
                  <li><RouterLink href='/about/privacy-policy'>Privacy Policy And Your California Privacy Rights</RouterLink></li>
                  <li><RouterLink href='/about/copyright'>Addicting Games Copyright Compliance Policy</RouterLink></li>
                  <li><RouterLink href='/about/upload'>Developer Center</RouterLink></li>
                  <li><RouterLink href='/about/advertisers'>Advertising Opportunities</RouterLink></li>
                  <li><RouterLink href='/about/content-ratings'>What Do Our Ratings Mean?</RouterLink></li>
                  <li><RouterLink href='/about/parents'>For Parents And Guardians</RouterLink></li>
                  <li><RouterLink href='https://www.addictinggames.com/blog'>Blog</RouterLink></li>
                  <li><RouterLink href='/playlists'>Top Site Lists</RouterLink></li>
                </MenuList>
              </Menu>
            </Flex>
            <Flex>
              {props.children}
            </Flex>
          </Flex>
        </Container>
      </App.Main>

      <App.Footer>
        <AppFooter />
      </App.Footer>
    </Layout>
  );
});
